import { render, staticRenderFns } from "./IngressData.vue?vue&type=template&id=f1208a80&"
import script from "./IngressData.vue?vue&type=script&lang=js&"
export * from "./IngressData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports